import {
  SHOW_LOADER,
  HIDE_LOADER,
  ADD_DATA_UPDATERS_FOR_WIDGETS,
  REMOVE_DATA_UPDATERS_OF_WIDGETS,
} from "./mdae-common-reducer";
import Guid from "devextreme/core/guid";
import { cloneDeep, first, isEqual } from "lodash";
import DataSource from "devextreme/data/data_source";
import $ from "jquery";
import ArrayStore from "devextreme/data/array_store";
import { nonLoaderActions } from "../constants/non-loader-actions";
import scrollView from "devextreme/ui/scroll_view";

const DX_WIDGET_NAMES = Object.freeze({
  DX_ACCORDION: "dxAccordion",
  DX_AUTOCOMPLETE: "dxAutoComplete",
  DX_BUTTON: "dxButton",
  DX_CALENDAR: "dxCalendar",
  DX_CHART: "dxChart",
  DX_CHECK_BOX: "dxCheckBox",
  DX_DATA_GRID: "dxDataGrid",
  DX_DATE_BOX: "dxDateBox",
  DX_DIAGRAM: "dxDiagram",
  DX_DRAWER: "dxDrawer",
  DX_DROP_DOWN_BOX: "dxDropDownBox",
  DX_FILE_UPLOADER: "dxFileUploader",
  DX_LIST: "dxList",
  DX_LOOKUP: "dxLookup",
  DX_MENU: "dxMenu",
  DX_NUMBER_BOX: "dxNumberBox",
  DX_PIE_CHART: "dxPieChart",
  DX_PIVOT_GRID: "dxPivotGrid",
  DX_POPOVER: "dxPopover",
  DX_POPUP: "dxPopup",
  DX_PROGRESS_BAR: "dxProgressBar",
  DX_RADIO_GROUP: "dxRadioGroup",
  DX_SELECT_BOX: "dxSelectBox",
  DX_TAB_PANEL: "dxTabPanel",
  DX_TABS: "dxTabs",
  DX_TEXT_AREA: "dxTextArea",
  DX_TEXT_BOX: "dxTextBox",
  DX_TOAST: "dxToast",
  DX_TOOLTIP: "dxTooltip",
  DX_TREE_LIST: "dxTreeList",
  DX_TREE_VIEW: "dxTreeView",
  DX_VALIDATOR: "dxValidator",
  DX_SCROLL_VIEW: "dxScrollView",
  DX_TREEE_VIEW: "dxTreeView",
});

export interface IMdaeDataUpdaterConfig {
  actionType?: string;
  updateHandler?: Function;
  isAsyncComplete?: boolean;
  widgetOptionBindings?: any;
  dataSourceOptions?: any;
  reducerName?: any;
}

/* UTIL FUNCTION */
const isPropertySelectorExpr = (propertyPath) => {
  const propPath = propertyPath.toLowerCase();
  const jsOperatorsList = [
    "&&",
    "==",
    "!=",
    "!",
    "||",
    ">",
    ">=",
    "<",
    "<=",
    "===",
    "!==",
    "+",
    "-",
    "*",
    "%",
  ];
  for (let i = 0; i < jsOperatorsList.length; i++) {
    if (propPath.indexOf(jsOperatorsList[i]) > 0) {
      return true;
    }
  }
};

const getNestedPropertyValue = (propertyPath, valueObject) => {
  if (isPropertySelectorExpr(propertyPath) && valueObject) {
    const propPath = "valueObject." + propertyPath;
    return eval(propPath);
  } else {
    var schema = valueObject;
    var pList = propertyPath.split(".");
    var len = pList.length;
    for (var i = 0; i < len; i++) {
      var elem = pList[i];
      if (!schema[elem] && typeof schema[elem] != "object") return schema[elem];
      schema = schema[elem];
    }
    return schema;
  }
};
const setNestedPropertyValue = (propertyPath, valueObject, value) => {
  if (propertyPath.includes(".")) {
    var schema = valueObject;
    var pList = propertyPath.split(".");
    var len = pList.length;
    for (var i = 0; i < len - 1; i++) {
      var elem = pList[i];
      if (!schema[elem]) schema[elem] = {};
      schema = schema[elem];
    }

    schema[pList[len - 1]] = value;
  } else {
    valueObject[propertyPath] = value;
  }
};

const getWidgetOptionNameListFor2WayBinding = (widgetOptionBindings) => {
  const widgetOptionNames = [];
  if (widgetOptionBindings) {
    for (let prop in widgetOptionBindings) {
      if (
        !(
          prop.toLowerCase().includes("datasource") ||
          prop.toLowerCase().includes("items") ||
          isPropertySelectorExpr(widgetOptionBindings[prop])
        )
      )
        widgetOptionNames.push(prop);
    }
  }
  return widgetOptionNames;
};

/* UTIL FUNCTION END*/

const addReducerDataUpdaterBindings = (
  component,
  widgetDataUpdaterConfig,
  dispatchHandler
) => {
  const widgetOptionBindings = widgetDataUpdaterConfig?.widgetOptionBindings;
  const widgetOptionNames = getWidgetOptionNameListFor2WayBinding(
    widgetOptionBindings
  );

  if (widgetOptionNames.length) {
    component.on("optionChanged", (e) => {
      if (widgetOptionNames.includes(e.name)) {
        dispatchHandler({
          type: widgetDataUpdaterConfig.actionType,
          data: {
            isMdaeWidgetOptionUpdater: true,
            propertySelector: widgetOptionBindings[e.name],
            updatedValue: e.value,
          },
        });
      }
    });
  }
};
const updateStateAfterWidgetOptionChange = (state, actionData) => {
  if (actionData.isMdaeWidgetOptionUpdater) {
    setNestedPropertyValue(
      actionData.propertySelector,
      state,
      actionData.updatedValue
    );
    return state;
  }
};

const isMdaeWidgetOptionChangeEvent = (actionData) => {
  if (actionData && actionData.isMdaeWidgetOptionUpdater) return true;
  return false;
};

const addWidgetOptionUpdaters = (
  widgetName,
  component,
  dispatch,
  widgetUpdaterData
) => {
  if (widgetUpdaterData) {
    const guid = new Guid().toString();
    component.option("elementAttr", {
      mdaeDxWidgetIdentifier: guid,
    });

    let widgetOptionUpdater;
    switch (widgetName) {
      default:
        widgetOptionUpdater = (
          data,
          widgetDataUpdaterConfig,
          reducerNewState
        ) => {
          const widgetOptionBindings =
            widgetDataUpdaterConfig.widgetOptionBindings;
          if (widgetOptionBindings) {
            for (let widgetOptionName in widgetOptionBindings) {
              let newOptionValue;
              const valuePropPath = widgetOptionBindings[widgetOptionName];
              let oldWidgetPropValue;
              let existingDataSource;
              if (widgetOptionName.toLowerCase() === "datasource") {
                existingDataSource = component.option(widgetOptionName);
                if (
                  existingDataSource &&
                  typeof existingDataSource.store === "function"
                )
                  oldWidgetPropValue = existingDataSource.store();
                else {
                  oldWidgetPropValue = existingDataSource;
                }
              } else {
                oldWidgetPropValue = component.option(widgetOptionName);
              }

              let isUpdateWidgetOption = false;
              if (widgetDataUpdaterConfig.isAsyncComplete) {
                if (valuePropPath) {
                  newOptionValue = getNestedPropertyValue(valuePropPath, data);
                } else {
                  newOptionValue = data;
                }
              } else {
                newOptionValue = getNestedPropertyValue(
                  valuePropPath,
                  reducerNewState
                );
              }

              if (
                !isEqual(oldWidgetPropValue, newOptionValue) ||
                widgetOptionName.toLowerCase() === "mdaescrolltop"
              ) {
                isUpdateWidgetOption = true;
              }
              if (isUpdateWidgetOption) {
                if (widgetOptionName.toLowerCase() === "datasource") {
                  const dataSource = new DataSource({
                    store: new ArrayStore({
                      data: newOptionValue,
                      ...widgetDataUpdaterConfig?.dataSourceOptions
                        ?.storeOptions,
                    }),
                    ...widgetDataUpdaterConfig?.dataSourceOptions
                      ?.dataSourceOptions,
                  });

                  component.option(widgetOptionName, dataSource);
                } else if (
                  widgetOptionName.toLowerCase() === "mdaepopuptitle"
                ) {
                  $(component.content())
                    .parent("div.dx-overlay-content")
                    .find(".mdae-popup-title-bar .mdae-popup-title-bar-text")
                    .text(newOptionValue);
                } else if (widgetOptionName.toLowerCase() === "mdaescrolltop") {
                  if (data?.myTaskDrawerId) {
                    var scrollBarInstance: any = scrollView.getInstance(
                      $(
                        "[myTaskDrawerScrollViewId=" + data.myTaskDrawerId + "]"
                      ) as any
                    );
                    const scrollToConfig =
                      reducerNewState.myTaskDrawerScrollConfig[
                        data.myTaskDrawerId
                      ]?.mdaeScrollTop;
                    const oldScrollToConfig = {
                      left: Math.abs(scrollBarInstance?.scrollLeft()),
                      top: Math.abs(scrollBarInstance?.scrollTop()),
                    };
                    if (!isEqual(oldScrollToConfig, scrollToConfig))
                      scrollBarInstance?.scrollTo(scrollToConfig);
                  } else {
                    const oldScrollToConfig = {
                      left: Math.abs(component?.scrollLeft()),
                      top: Math.abs(component?.scrollTop()),
                    };
                    if (
                      isEqual(oldScrollToConfig, reducerNewState.mdaeScrollTop)
                    )
                      component?.scrollTo(reducerNewState.mdaeScrollTop);
                  }
                } else component.option(widgetOptionName, newOptionValue);
              }
            }
          }
        };
        break;
    }

    if (widgetUpdaterData && widgetUpdaterData.length) {
      for (let i = widgetUpdaterData.length - 1; i >= 0; i--) {
        if (widgetUpdaterData[i].actionType) {
          widgetUpdaterData[i].updateHandler = widgetOptionUpdater;

          addReducerDataUpdaterBindings(
            component,
            widgetUpdaterData[i],
            dispatch
          );
        } else {
          delete widgetUpdaterData[i];
        }
      }
    }
    if (widgetUpdaterData && widgetUpdaterData.length)
      dispatch({
        type: ADD_DATA_UPDATERS_FOR_WIDGETS,
        widgetUpdaterData: widgetUpdaterData,
        mdaeDxWidgetIdentifier: guid,
      });
  }
};

const removeWidgetOptionUpdaters = (component, dispatch, widgetUpdaterData) => {
  if (widgetUpdaterData) {
    const mdaeDxWidgetIdentifier = component.option(
      "elementAttr.mdaeDxWidgetIdentifier"
    );
    dispatch({
      type: REMOVE_DATA_UPDATERS_OF_WIDGETS,
      widgetUpdaterData: widgetUpdaterData,
      mdaeDxWidgetIdentifier: mdaeDxWidgetIdentifier,
    });
  }
};

var asyncActionsInProgress = {};

/* The registry of work the global loader is waiting on. Keyed by async-ops
   operation name for the classic pages; the RTK Query middleware in
   ../store/rtk-query-loader-middleware adds its own requestId-based keys to the
   same object so both mechanisms share one loader and one hide guard. */
export const addAsyncActionInProgress = (key: string) => {
  asyncActionsInProgress[key] = true;
};
export const removeAsyncActionInProgress = (key: string) => {
  delete asyncActionsInProgress[key];
};
export const hasAsyncActionsInProgress = () => {
  const propList = Object.getOwnPropertyNames(asyncActionsInProgress);
  return !!(propList && propList.length);
};

function addRemoveAsyncActionNames(actionName, actionType) {
  if (actionType && actionType.toUpperCase() === "ASYNC_OPERATION") {
    addAsyncActionInProgress(actionName);
  } else if (actionType && actionType.toUpperCase() === "ASYNC_COMPLETE") {
    removeAsyncActionInProgress(actionName);
  }
}

function isShowLoader() {
  return hasAsyncActionsInProgress();
}

const updateWidgetOptionsHandler = (storeNewState, actionData) => {
  const commonReducerstate = storeNewState["mdaeCommonReducer"];
  if (
    commonReducerstate &&
    commonReducerstate.widgetOptionUpdator &&
    !isMdaeWidgetOptionChangeEvent(actionData.data)
  ) {
    let actionTypeName = "";
    if (actionData.type === "ASYNC_COMPLETE") {
      actionTypeName = actionData.name;
    } else {
      actionTypeName = actionData.type;
    }
    const widgetOptionUpdators =
      commonReducerstate.widgetOptionUpdator[actionTypeName];
    if (widgetOptionUpdators) {
      let actionUpdatedData;
      if (actionData.type === "ASYNC_COMPLETE") {
        actionUpdatedData = actionData.response;
      } else {
        actionUpdatedData = actionData.data;
      }
      for (let prop in widgetOptionUpdators) {
        const widgetDataUpdator = widgetOptionUpdators[prop];
        for (let i = 0; i < widgetDataUpdator.length; i++) {
          const updateHandler = widgetDataUpdator[i].updateHandler;
          if (typeof updateHandler === "function") {
            const reducerNewState =
              storeNewState[widgetDataUpdator[i].reducerName];
            updateHandler(
              actionUpdatedData,
              widgetDataUpdator[i],
              reducerNewState
            );
          }
        }
      }
    }
  }
};

const hideShowCommonLoader = (action, store) => {
  if (
    (action.type && action.type.toUpperCase() === "ASYNC_OPERATION") ||
    (action.type && action.type.toUpperCase() === "ASYNC_COMPLETE")
  ) {
    if(!nonLoaderActions[action.name]){
      addRemoveAsyncActionNames(action.name, action.type);
      if (isShowLoader()) {
        store.dispatch({ type: SHOW_LOADER });
      } else{
        store.dispatch({ type: HIDE_LOADER });
      }
    }
  }
};

const mdaeWidgetDataUpdaterMiddleware = (store) => {
  return (next) => (action) => {
    hideShowCommonLoader(action, store);

    const returnVal = next(action);

    updateWidgetOptionsHandler(store.getState(), action);

    return returnVal;
  };
};

const configureMdaeWidgetOptionUpdaters = (
  dataUpdaterConfig: Array<IMdaeDataUpdaterConfig>,
  componentType,
  component,
  dispatchHandler
) => {
  addWidgetOptionUpdaters(
    componentType,
    component,
    dispatchHandler,
    dataUpdaterConfig
  );
  component.on("disposing", (e) => {
    removeWidgetOptionUpdaters(component, dispatchHandler, dataUpdaterConfig);
  });
};

export {
  DX_WIDGET_NAMES,
  addWidgetOptionUpdaters,
  removeWidgetOptionUpdaters,
  mdaeWidgetDataUpdaterMiddleware,
  configureMdaeWidgetOptionUpdaters,
  isMdaeWidgetOptionChangeEvent,
  updateStateAfterWidgetOptionChange,
  getNestedPropertyValue,
  asyncActionsInProgress,
};

export const checkListIsEqual = (left: any[], right: any[]) => {
  if (!Array.isArray(left) || !Array.isArray(right)) return left === right;
  if (isEqual(first(left)?.version, first(right)?.version)) {
    return true;
  }
  return false;
};

export const assignVersionToList = (list: any[]) => {
  const guid = new Guid().toString();
  if (list?.length > 0) {
     const newListitem = cloneDeep(list[0]);
     newListitem.version = guid + new Date().getTime();
     return [newListitem, ...list.slice(1)];
  }
  return list;
};
